import { createContext, ReactElement, ReactNode, useContext, useState } from 'react';

type Props = {
  isLoggedIn: boolean
  children: ReactNode
}

type ContextValue = {
  isLoggedIn: boolean,
  setIsLoggedIn: (value: boolean) => void,
};

const AuthContext = createContext<ContextValue | null>(null);

export function AuthProvider({
  isLoggedIn: initialIsLoggedIn,
  children,
}: Props): ReactElement {
  const [isLoggedIn, setIsLoggedIn] = useState(initialIsLoggedIn);

  const contextValue: ContextValue = {
    isLoggedIn,
    setIsLoggedIn,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth(): ContextValue {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
}
